<template>
  <div :class="visitSource ==2?'look_pc':(ifHead?'look':'')">
    <!--visitSource = 2 pc端 -->
    <template v-if="visitSource == 2">
      <examinationHeader v-if="ifHead" ref="header" :initActiveName="pageInfo.initActiveName+''" ></examinationHeader>
      <el-row type="flex" justify="center">
        <el-col :xs="24" :sm="24" :md="ifHead?18:24" :lg="ifHead?18:24" :xl="ifHead?18:24">
          <kw_look ref="kw_look" id="kw_look" v-if="(pageInfo.ifLoaded)" :pageInfo="pageInfo" @refreshevent="zdyRefreshPage" @goBack="goBack" :isLimitButton="isLimitButton"></kw_look>
        </el-col>
      </el-row>
      <examinationFooter v-if="ifHead"></examinationFooter>
    </template>

    <!--visitSource = 3  移动端 -->
    <div v-else>
      <div class="title_container" v-if="ifHead">
        <i class="el-icon-arrow-left" @click="goBack" style="font-weight: bold"></i>
        <!-- <img src="../../../components/list/img/logo.png" alt="logo" class="logo_img"> -->
        <span class="system_title">{{loginTitle}}</span>
      </div>
      <kw_look ref="kw_look" id="kw_look" v-if="(pageInfo.ifLoaded)" :pageInfo="pageInfo" @refreshevent="zdyRefreshPage" @goBack="goBack" :isLimitButton="isLimitButton"></kw_look>
    </div>
    <!-- <customer_service customerInfo="{{customerInfo}}"></customer_service> -->

    <!-- 分享图片 画布生成功能 -->
    <!-- <kw_image_canvas wx:if="{{imageCanvasInfo.ifLoad}}" dataInfo="{{imageCanvasInfo.dataInfo}}" buttonSet="{{imageCanvasInfo.buttonSet}}"></kw_image_canvas> -->

    <!-- 底部弹窗分享按钮组 -->
    <!-- <kw_bottom_window wx:if="{{shareButtonInfo.ifLoad}}" shareButtonInfo="{{shareButtonInfo}}"></kw_bottom_window> -->

  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
//PC考试底部内容
import examinationFooter from '@/components/footer/examinationFooter.vue';
//PC考试头部内容
import examinationHeader from '@/components/header/examinationHeader.vue';
export default {
  name: 'look',
  props: {
    
  },
  data() {
    return {
      // 访问来源 PC:2 或者 H5:3
      visitSource:utils.checkVisitSource(),
      //页面Id
      pageInfo:{
        tableId: 448,
        pageId: 22592,
        pageType:11,
        listTableId: 448,
        mainId: 139176,
        // callBackType
        ifLoaded:false
      },
      // 扫码进入时传递的 参数
      scene_id: "",
      // 扫码进入时传递的 需要传递到后台的参数
      sceneJson: {},
      /**
       * 联系客服功能
       */
      customerInfo: {
        // 是否显示
        show: false,
        // 显示的微信号
        initContents: null,
        // 显示的微信二维码
        initCodeUrl: null
      },
      // 分享图片 画布生成功能
      imageCanvasInfo: {
        ifLoad: false
      },
      // 底部弹窗分享按钮组
      shareButtonInfo: {
        ifLoad: false
      },
      ifHead:true,
      //打开方式
      openWay:null,
      loginTitle:"可为低代码平台",
      //按钮是否根据角色权限限制
      isLimitButton: false,
    };
  },
  created() {
    var that = this;
    // 判断移动端是否是flutter内打开
    console.log("look页面visitSource=======================", this.visitSource);
    if(this.visitSource == 3) {
      try {
        var ifHead = _flutterToOpenLookPage.postMessage?false:true;
        this.ifHead = ifHead;
      } catch (error) {
      }
    }
    if(localStorage.domain_name && localStorage.domain_name != "") {
      that.loginTitle = that.GLOBAL.loginProductName[localStorage.domain_name];
    } else {
      that.loginTitle = that.GLOBAL.defaultProductName;;
    }
    //请求地址传递的参数
    var options = this.$route.params;

    if(!options.pageId) {
      options = this.$route.query;
    }
      console.log("look页面options=======================", options);
    var kw_param = options.kw_param;
    var state = options.state;
    var CODE = options.CODE;
    if(options.noHead==1) {
      that.ifHead = false;
    }
    if(options.openWay==2) {
      that.openWay = 2;
    }
    if(options.isLimitButton  ||  options.isLimitButton == "true") {
      that.isLimitButton = true;
    }
    kw_param = utils.kwAtob(kw_param);
    var kwParamArr = kw_param.split("_");
    var lookParam = that.GLOBAL.lookParam;
    lookParam.forEach((key,keyIndex) => {
      if(kwParamArr.length>keyIndex && kwParamArr[keyIndex] != "") {
        options[key] = kwParamArr[keyIndex];
      }
    });
    // options = JSON.parse(kw_param);
    console.log("options==========================",options);
    var that = this;
    var pageInfo = that.pageInfo;
    if(state == 1) {
      pageInfo.wxPayState = 1;
      pageInfo.wxPayCode = CODE;
    }
    if (options) {
      pageInfo = options;
      if (!(pageInfo.pageType>0)) {
        pageInfo.pageType = 11;
      }
      if (!pageInfo.listTableId) {
        pageInfo.listTableId = pageInfo.tableId;
      }
      if (!pageInfo.tableId) {
        pageInfo.tableId = 18073;
        pageInfo.pageId = 22635;
      }
      
      // if(pageInfo.menuName) {
      //   that.loginTitle = pageInfo.menuName;
      // }
      pageInfo.ifLoaded = true;
    } else {
      pageInfo.ifLoaded = true;
    }
    console.log("pageInfo======================", pageInfo);
    // 如果是扫码进入 获取扫码的参数信息 并进行处理 传递到后台
    pageUtils.initScene(this, options.scene, pageInfo);
    // 如果进入的查看页面没有主键信息 则跳转进入首页
    if (!pageInfo.mainId>0) {
      // that.$router.push({
      //     name: 'MainPage',
      //     params: {
      // }});
    }
    that.pageInfo = pageInfo;
    pageUtils.flutterWebPageFinished();
  },
  mounted() {
    var that = this;
    // 调用转发的初始化方法
    // utils.initWxShare(this);
    window.zdyRefreshPage = (e) => {
      that.zdyRefreshPage();
    }
  },
  watch:{
  },
  computed:{
  },
  components: {
    examinationFooter,
    examinationHeader,
    kw_look:resolve => require(['@/components/look/kw_look.vue'], resolve),
  },
  methods: {
    //    后退
    goBack(){
      var that = this;
      console.log("that.$router=====================================",that.$router,that.$router.history.current.path);
      console.log("window.history.length============================",window.history);
      // 判断查看或者列表页面是否设置为返回首页
      var prevIfHome = 0;
      var prevHistoryNum = 0;
      if(that.$refs.kw_look && that.$refs.kw_look.pageSetInfo && that.$refs.kw_look.pageSetInfo.styleSet) {
        prevIfHome =  that.$refs.kw_look.pageSetInfo.styleSet.prevIfHome;
        prevHistoryNum = that.$refs.kw_look.pageSetInfo.styleSet.prevHistoryNum;
      } 
      if(that.$router.history && that.$router.history.current.path.indexOf("/mailHome")>=0) {
        prevIfHome = 1;
      }
      console.log("prevIfHome============================",prevIfHome,prevHistoryNum);
      var ifWxMiniProgram = false;
      wx.miniProgram.getEnv(function(res) {
          console.log("res.miniprogram==========================",res) // true
          if(res.miniprogram) {
              if(prevIfHome == 1) {
                //跳转首页
                wx.miniProgram.reLaunch({
                  url: '/pages/home/mailHome'
                })
              } else {
                //关闭当前页并返回上一页
                wx.miniProgram.navigateBack({})
              }
              ifWxMiniProgram = true;
          }
      })
      if(!ifWxMiniProgram) {
        //判断是否是flutter环境，如果是则调用前一个页面的刷新方法
        var ifFlutter = false;
        try {
          _flutterClosePage.postMessage(prevIfHome);
          ifFlutter = true;
        } catch (error) {
          ifFlutter = false;
        }
        if(!ifFlutter) {
          console.log("prevIfHome==========================",prevIfHome,that.$router);
          if(prevIfHome == 1) {
            pageUtils.toMailHome(that);
          } else {
            console.log("back一下!");
            if(prevHistoryNum > 0) {
              that.$router.go(0-prevHistoryNum);
            } else {
              that.$router.go(-1);
            }
          }
        }
      }
    },
    /**
     * 刷新页面的操作
     */
    zdyRefreshPage:function(){
      var that = this;
      var pageInfo = this.pageInfo;
      pageInfo.ifLoaded = false;
      that.pageInfo = pageInfo;
      that.$nextTick(function(){
        pageInfo.ifLoaded = true;
        that.pageInfo = pageInfo;
      });
    },
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .look{background: linear-gradient(#FEFEFE, #FBFBFB);padding-top: 37px}
  .title_container{padding: 5px;position: fixed;top: 0;left: 0;background: #ffffff;width: 100%;z-index: 999}
  .logo_img{width: 25px;height: 25px;margin-left: 40px}
  .system_title{font-size: 18px;color: #000;vertical-align:middle}
  .el-icon-arrow-left{font-size: 20px;vertical-align: middle;font-weight: bold}
  .el-footer{padding: 0}
</style>
